import { useSelector } from "react-redux";

import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import Filter from "components/__new/common/Filter";
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/Plus.svg"
import { TableContent } from "components/__new/common/TableContent";
import { DateFormat, TimeFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import ContentLoading from "components/__new/common/ContentLoading";
import pluralize from "utils/pluralize";
import TableEmptyData from "components/__new/common/TableEmptyData";
import { truncate } from "utils/truncate";


export const InstantTransfersTable = ({toggleTransferDestination, openTransactionDetails, loading}) => {
    const { transactionsLoading, transactions } = useSelector((s) => s.entities.wallet);

    return (
        <div>

            <div className="mt-6 box">
                
                <div className="flex items-center justify-start w-max">
                    <div className="font-medium">Instant Transfers&nbsp;</div>
                    
                    <div className="label h-6 text-sm font-normal text-ep-primary-600 bg-[#ecf2f2]">
                        <ContentLoading
                            loading={transactionsLoading || loading}
                            data={<>{transactions?.data?.totalDocs ?? "-"} {pluralize(transactions?.data?.totalDocs, "transfer", "transfers")}</>}
                        />
                    </div>
                </div>
                
                <div className="mt-6 flex flex-wrap justify-between">
                    <div className="max-w-sm flex-grow sm:mr-6">
                        <SearchBox placeholder="Search" name="search" extraUrlParams="page=1" />
                    </div>
                        
                    <div className="flex flex-wrap space-x-3 sm:space-x-3 mt-5 lg:mt-0">
                        <div>
                            <Filter filters={[
                                {
                                    title: "Status",
                                    name: "status",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Successful",
                                            payload: "successful",
                                        },
                                        {
                                            display: "Pending",
                                            payload: "pending",
                                        },
                                        {
                                            display: "Failed",
                                            payload: "failed",
                                        },
                                    ],
                                },
                                {
                                    title: "Date Range",
                                    dataType: "date-range",
                                    options: {
                                        from: {
                                            name: "startDate",
                                            placeholder: "Start Date",
                                        },
                                        to: {
                                            name: "endDate",
                                            placeholder: "End Date",
                                        },
                                    },
                                },
                            ]}/>
                        </div>

                        <div>
                            <button type="button" onClick={toggleTransferDestination} className="btn btn-ep-primary rounded-lg flex items-center justify-center h-full">
                                <IconAdd width={15} className="mr-2" />
                                <span>New instant transfer</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white">

                <Table classTable="table-hover">
                    <Table.Head>
                        <th>Date</th>
                        <th>Recipient</th>
                        <th>Narration</th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th>Balance</th>
                    </Table.Head>
                    <Table.Body>

                        <TableContent
                            loading={transactionsLoading || loading}
                            loadingText="Fetching Transfers"
                            data={transactions?.data}
                            colspan={6}
                            emptyUI={
                                <TableEmptyData
                                    useSubtitle
                                    actionButtonClicked={toggleTransferDestination}
                                />
                            }
                        />

                        {transactionsLoading === false && !loading && transactions?.data?.docs?.map((transaction) => {
                            return (
                                <tr key={transaction?._id} onClick={() => openTransactionDetails(transaction)}>
                                    <td>
                                        <div>{DateFormat(transaction?.createdAt)} at {TimeFormat(transaction?.createdAt)}</div>
                                    </td>
                                    <td className="capitalize">
                                        {transaction?.sourceType === "bill-payment" && transaction?.product === "airtime" && (transaction?.providerResponse?.phone ?? "-")}
                                        {transaction?.sourceType === "bill-payment" && transaction?.product === "electricity" && (transaction?.providerResponse?.meterNumber ?? "-")}
                                        {transaction?.sourceType === "bill-payment" && transaction?.product === "data" && (transaction?.providerResponse?.phone ?? "-")}
                                        {transaction?.sourceType === "bill-payment" && transaction?.product === "tv" && (transaction?.providerResponse?.smartcardNumber ?? "-")}
                                        {transaction?.product === "general" && transaction?.type === "credit" && !transaction?.description?.startsWith("RVSL_NIP") && "-"}
                                        {transaction?.product === "charge" && "Transfer Charges"}
                                        {transaction?.product === "general" && !transaction?.description?.startsWith("RVSL_NIP") && transaction?.destinationAccountNumber}
                                        {transaction?.product === "payroll" && "Monthly Payroll"}
                                        {transaction?.product === "general" && transaction?.description?.startsWith("RVSL_NIP") && "Reversal"}
                                    </td>
                                    <td className="capitalize">
                                        {truncate(transaction?.description, 30) || "-"}
                                    </td>
                                    <td>
                                        <div className={"text-xs capitalize label " + renderStatusColor(transaction?.status)}>
                                            {transaction?.status}
                                        </div>
                                    </td>
                                    <td>
                                        {CurrencyFormat(transaction?.amount / 100)}
                                    </td>
                                    <td>
                                        {CurrencyFormat(transaction?.newBalance / 100)}
                                    </td>
                                </tr>
                            )}
                        )}
                    </Table.Body>
                </Table>

                <Maybe condition={transactionsLoading === false && transactions?.data?.docs?.length > 0}>
                    <div className="mt-6">
                        <Pagination data={transactions?.data} />
                    </div>
                </Maybe>

            </div>
        </div>
    )
}


export default InstantTransfersTable;
